"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logHttpErrorWithSentry = exports.buildSentryContextForError = void 0;
const tslib_1 = require("tslib");
const Sentry = tslib_1.__importStar(require("@sentry/react"));
const createConfig_1 = tslib_1.__importDefault(require("../config/createConfig"));
const Header_1 = tslib_1.__importDefault(require("../constants/Header"));
function maskGuidInUrl(url) {
    const guidRegex = /[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}/gi;
    return url.replace(guidRegex, "*").split("?")[0];
}
function buildSentryContextForError({ context, errorBody, requestInfo, response, }) {
    const currentMfe = requestInfo.init.headers.get("x-mfe-origin");
    context.setTag("current_mfe", currentMfe);
    // To avoid sending personal data in the query params to Sentry, we'll just send the url which can include GUIDs
    const sanitisedUrl = requestInfo.fullUrl.split("?")[0];
    context.setTag("request_url", sanitisedUrl);
    context.setTag("request_url_masked", maskGuidInUrl(sanitisedUrl));
    // Status gives us the HTTP status code
    context.setTag("error_status", response.status);
    // When there is a more specific error code, we'll send that too
    context.setTag("error_status_code", errorBody.Code);
    // Having the correlation id allows us to search Sentry for the error and
    context.setTag("xCorrelationId", response.headers.get(Header_1.default.CORRELATION));
    return context;
}
exports.buildSentryContextForError = buildSentryContextForError;
function logHttpErrorWithSentry({ error, requestInfo, response, errorBody, }) {
    const { config } = (0, createConfig_1.default)();
    if (config("sentry.enabled")) {
        Sentry.captureException(error, (context) => buildSentryContextForError({
            context,
            errorBody,
            requestInfo,
            response,
        }));
    }
}
exports.logHttpErrorWithSentry = logHttpErrorWithSentry;
//# sourceMappingURL=logHttpErrorWithSentry.js.map